<div [ngClass]="{'short-message': true, 'has-notify': !!message.status}">
    <div class="shimmer">
      <div class="notify" *ngIf="hasWarning(message)">
        <i class="icon warning">
          <svg width="16px" height="16px" viewBox="0 0 23 23" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <circle cx="11.5" cy="11.5" r="11" fill="#EC506E" stroke="none"></circle>
            <path
              d="M 0.366695,10.308817 V 0.262695 h 2.0329317 v 10.046122 z m 0,3.318319 0,-1.868834 h 2.0329317 v 1.868834 z"
              fill="#FFFFFF" stroke="none" transform="translate(10, 4)"></path>
          </svg>
        </i>
      </div>
      <div class="content">
        <div class="title">{{message.sender}}</div>
        <div class="summary">{{message.message}}</div>
      </div>
    </div>
    <div class="remove-icon" *ngIf="editable">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 22 22" (click)="onDelete($event)">
        <path d="M2.516.307a1.5 1.5 0 0 0-1.063.44l-.707.706a1.502 1.502 0 0 0 0 2.123L8.17 11 .746 18.424a1.502 1.502 0 0 0 0 2.123l.707.707a1.502 1.502 0 0 0 2.123 0L11 13.83l7.424 7.424a1.502 1.502 0 0 0 2.123 0l.707-.707a1.502 1.502 0 0 0 0-2.123L13.83 11l7.424-7.424a1.502 1.502 0 0 0 0-2.123l-.707-.707a1.502 1.502 0 0 0-2.123 0L11 8.17 3.576.746a1.495 1.495 0 0 0-1.06-.44z" fill="#95a0b1" fill-rule="evenodd"/>
      </svg>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/main/influencer-home/short-message/short-message.component.html